export default "__VITE_ASSET__BYbSifN2__"